@if (isNoGrouped()) {
    <ng-container *transloco="let tTable; read: 'table'">
        @if (isAssignee()) {
            <span class="p-2 inline-block"> {{ tTable('unassigned') }} </span>
        }
        @if (isStatus()) {
            <app-input-cell-container
                [field]="field()"
                [readonly]="true"
                [value]="value()"
                [appearance]="'board'"
            ></app-input-cell-container>
        }
        @if (!isAssignee() && !isStatus()) {
            <span class="p-2 inline-block"> {{ tTable('unknown') }} </span>
        }
    </ng-container>
}
@if (!isNoGrouped() && field()) {
    <app-input-cell-container
        [field]="field()"
        [readonly]="true"
        [value]="value()"
        [appearance]="'board'"
    ></app-input-cell-container>
}
